const fields = [
  'PDB_Projekttyp',
  'PDB_Projektnummer',
  'UE_Kundendaten_Projekttitel',
  'BC_UseCase',
  'BC_FahrzeugTyp',
  'PDB_WasVerkauft',
  'PDB_LieferterminVerbindlich',
  'PDB_LieferterminGewuenscht',
  'PDB_VertriebsmitarbeiterId',
  'PDB_InnendienstmitarbeiterId',
  'PDB_ProjektentwicklungId',
  'PDB_ProjektiererId',
  'PDB_Projektleiter_PMOId',
  'PDB_Ansprechpartner_Projektsupport',
  'PDB_Ansprechpartner_TBFId',
  'PDB_Auftragsnummer',
  'PDB_Auftragsnummer_Nachtrag0', // I
  'PDB_Auftragsnummer_Nachtrag1', // II
  'PDB_Auftragsnummer_Nachtrag2', // III
  'PDB_Auftragsnummer_Nachtrag3', // IV
  'PDB_Auftragsnummer_Nachtrag4', // V
  'PDB_Planung_verkauft',
  'PDB_Auftragsnummer_Planung',
  'PDB_Servicevertrag_verkauft',
  'PDB_kein_SV_GF_Freigabe',
  'PDB_Servicevertrag_Angebot',
]
const key = 'Projektdaten'

export const fieldOrderProjektdaten = { [key]: { fields } }

export const formGroupProjektdaten = {
  key,
  title: key,
  form: key,
}
